import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { MessagesService } from '@core/services/messages.service';

import {
  listMessagesByRoomAction,
  listMessagesByRoomActionSuccess,
  listMessagesByRoomActionFailure,
} from './messages.actions';

@Injectable()
export class MessagesEffects {
  constructor(
    private actions$: Actions,
    private messagesService: MessagesService,
    private toastr: ToastrService
  ) {}

  listMessagesByRoom$ = createEffect(() =>
    this.actions$.pipe(
      ofType(listMessagesByRoomAction),
      switchMap((action) =>
        this.messagesService.listMessagesByRoom(action).pipe(
          map((res) =>
            listMessagesByRoomActionSuccess({
              listMessagesByRoom: res.listMessagesByRoom,
            })
          ),
          catchError(() => {
            this.toastr.error(
              'Unable to update your messages. Please try again later or contact support.',
              'My Messages'
            );
            return [listMessagesByRoomActionFailure()];
          })
        )
      )
    )
  );
}
